Ext.ns('mx.app.widget');

mx.app.widget.MapForm = Ext.extend(mx.comp.FormPanel, {
    layout: 'row',
    border: false,
    header: false,
    height: 550,
    //    autoHeight : true,
    readOnly: false,
    params: {
        address: null,
    },
    labels: {
        map: 'Map',
        searchPosition: 'Search position',
        search: 'Search',
        address: 'Address',
        latlon: 'Lat. / Lon.',
    },
    inputs: {}, // collection of input elements
    components: {},
    initComponent: function() {
        mx.app.widget.MapForm.superclass.initComponent.apply(this, arguments);
        var thiz = this;

        this.inputs = {
            searchTextfield: new Ext.form.TextField({
                name: 'search_text',
            }),
            searchButton: new Ext.ux.ResizableButtonComponent({
                name: 'search_address_btn',
            }),
            addressTextfield: new Ext.form.TextField({
                readOnly: true,
                name: 'adress_text',
            }),
            latitudeTextfield: new Ext.form.TextField({
                readOnly: true,
                name: 'latitude_text',
            }),
            longitudeTextfield: new Ext.form.TextField({
                readOnly: true,
                name: 'longitude_text',
            }),
        };

        var name = this.params.address.get ? '' : this.params.address.name;

        // init search textfield
        this.inputs.searchTextfield.setValue(name);
        this.inputs.searchTextfield.initEvents = function() {
            Ext.form.TextField.superclass.initEvents.call(this);
            this.keyNav = new Ext.KeyNav(this.el, {
                enter: function(e) {
                    this.inputs.searchButton.fireEvent('click');
                },
                scope: thiz,
            });
            this.el.on(
                'keyup',
                function() {
                    this.inputs.searchButton.setDisabled(
                        Ext.util.Format.trim(this.inputs.searchTextfield.getValue()).length == 0
                    );
                },
                thiz
            );
        };

        // init search button
        this.inputs.searchButton.setText(this.labels.search);
        if (!name || Ext.util.Format.trim(name).length == 0) {
            this.inputs.searchButton.setDisabled(true);
        }
        this.inputs.searchButton.on(
            'click',
            function() {
                if (Ext.util.Format.trim(this.inputs.searchTextfield.getValue()).length == 0) {
                    this.inputs.searchButton.setDisabled(true);
                } else {
                    this.components.mapComponent.searchOnMap(this.inputs.searchTextfield.getValue());
                }
            },
            thiz
        );

        // init address textfield
        this.inputs.addressTextfield.setValue(this.params.address.get ? this.params.address.get('name') : '');

        // init latitude textfield
        this.inputs.latitudeTextfield.setValue(this.params.address.get ? this.params.address.get('latitude') : '');

        // init longitude textfield
        this.inputs.longitudeTextfield.setValue(this.params.address.get ? this.params.address.get('longitude') : '');

        // init iframe component
        this.components.mapComponent = new mx.comp.mapComponent({
            id: this.id,
            mapParams: this.params.mapParams,
            callback: function(point) {
                // click on map callback
                thiz.components.mapComponent.updateCurrentPoint(point);
                thiz.inputs.addressTextfield.setValue(point.name);
                thiz.inputs.latitudeTextfield.setValue(point.lat);
                thiz.inputs.longitudeTextfield.setValue(point.lon);
                if (!point.lat && !point.lon) {
                    thiz.scope.buttons[0].disable();
                } else {
                    thiz.scope.buttons[0].enable();
                }
            },
            geocodingCallback: function(point) {
                thiz.components.mapComponent.callback(point);
            },
            onMapReadyCallback: function(aMap) {
                // search for initial address (not implemented)
                if (thiz.params.address.data) {
                    thiz.components.mapComponent.updateCurrentPoint(
                        new aMap.mxn.LatLonPoint(thiz.params.address.data.latitude, thiz.params.address.data.longitude)
                    );
                }
            },
            searchOnMap: function(text) {
                if (text) {
                    if (this.theMap && !this.theMap.noMap()) {
                        this.theMap.geocodingBasis({address: text});
                    } else {
                        //                        console.log("map error");
                    }
                }
            },
            addressFormatter: MXBT.formatAddress.createDelegate(MXBT),
        });

        // build window together:
        this.add(
            {
                layout: 'fit',
                border: false,
                rowHeight: 1,
                style: 'margin-bottom: 0px',
                items: [this.components.mapComponent],
            },
            {
                layout: 'form',
                height: 75,
                width: 500,
                border: false,
                defaults: {
                    anchor: '100%',
                },
                items: [
                    {
                        xtype: 'mx_fieldgroup',
                        fieldLabel: this.labels.searchPosition,
                        columns: [0.8, 10, 0.2],
                        items: [
                            this.inputs.searchTextfield,
                            {
                                xtype: 'label',
                                text: ' ',
                            },
                            this.inputs.searchButton,
                        ],
                    },
                    {
                        xtype: 'mx_fieldgroup',
                        fieldLabel: this.labels.address,
                        columns: [1],
                        items: [this.inputs.addressTextfield],
                    },
                    {
                        xtype: 'mx_fieldgroup',
                        fieldLabel: this.labels.latlon,
                        columns: [0.3, 10, 0.3],
                        items: [
                            this.inputs.latitudeTextfield,
                            {
                                xtype: 'label',
                                text: '/',
                                style: 'padding-left: 3px;',
                            },
                            this.inputs.longitudeTextfield,
                        ],
                    },
                ],
            }
        );
    },
});
